import AppContext from 'pages/AppContext.jsx';
import Config from 'Config';
import qs from 'qs';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/dom/ajax';


export const getSecurityParamsForHeader = () => {
    return {
        "accessToken": AppContext.persistentStore.getItem( "cmsAccessToken" ),
        "clientId": Config.ENV_API_CLIENT_ID,
        "key": Config.ENV_API_KEY,
        "lang": 'en-US'
    };
};

export const dbPost = (url, data, ajaxOptions) => Observable.ajax({
    url: Config.ENV_API_BASE_URL + url,
    crossDomain: true,
    headers: getSecurityParamsForHeader(),
    body: qs.stringify(data),
    method: 'POST',
  ...ajaxOptions
});


export const dbPostForm = (url, data, ajaxOptions) => {
    let formData = new FormData();
    let keys = Object.keys(data);
    for (let key of keys) {
        formData.append(key, data[key]);
    }

    return Observable.ajax({
        url: Config.ENV_API_BASE_URL + url,
        crossDomain: true,
        headers: getSecurityParamsForHeader(),
        body: formData,
        method: 'POST',
      ...ajaxOptions
    });
};

export const get = (url, params, ajaxOptions) => Observable.ajax({
    url: url + '?' + qs.stringify(params),
    crossDomain: true,
    headers: getSecurityParamsForHeader(),
    method: 'GET',
    ...ajaxOptions
});

export const dbGet = (url, params, ajaxOptions) => Observable.ajax({
    url: Config.ENV_API_BASE_URL + url + (params ? "?" + qs.stringify(params) : ""),
    crossDomain: true,
    headers: getSecurityParamsForHeader(),
    method: 'GET',
  ...ajaxOptions
});

export const dbPatch = (url, data, ajaxOptions) => Observable.ajax({
    url: Config.ENV_API_BASE_URL + url,
    crossDomain: true,
    headers: getSecurityParamsForHeader(),
    body: qs.stringify(data),
    method: "PATCH",
  ...ajaxOptions
});

export const dbDelete = (url, params, ajaxOptions) => Observable.ajax({
    url: Config.ENV_API_BASE_URL + url + (params ? "?" + qs.stringify(params) : ""),
    crossDomain: true,
    headers: getSecurityParamsForHeader(),
    method: 'DELETE',
  ...ajaxOptions
});

export const downloadFileData = (function (data, fileName) {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  return function (data, fileName) {
      const blob = new Blob([data], {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
  };
}());



// WEBPACK FOOTER //
// ./public/utils/ajaxUtils.js